module.exports = __webpack_public_path__ + "images/53c8d540272d88d79e503aecbe28721a.png";